import { RestResource } from "./common"
import type { INVESTMENT_EXPERIENCES } from "./customer"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EntitySuitability extends RestResource {
  annualNetIncome: number | null = null
  coveredOptionsTradingExperience?: INVESTMENT_EXPERIENCES
  futuresTradingExperience?: INVESTMENT_EXPERIENCES
  liquidNetWorth: number | null = null
  netWorth: number | null = null
  stockTradingExperience?: INVESTMENT_EXPERIENCES
  taxBracket: number | null = null
  uncoveredOptionsTradingExperience?: INVESTMENT_EXPERIENCES
}

export const ENTITY_SUITABILITY_DESER: SchemaDeSer<EntitySuitability> =
  new SchemaDeSerBuilder(EntitySuitability)
    .ofInt("annualNetIncome")
    .ofString("coveredOptionsTradingExperience")
    .ofString("futuresTradingExperience")
    .ofInt("liquidNetWorth")
    .ofInt("netWorth")
    .ofString("stockTradingExperience")
    .ofFloat("taxBracket")
    .ofString("uncoveredOptionsTradingExperience")
    .toDeSer()
